/**
 * Visitors Reducers
 */
import {
    VISITOR_ACTION,
    ALL_VISITOR,
    ADD_VISITOR,
    FETCH_VISITOR,
    EDIT_VISITOR,
    DELETE_VISITOR,
    AVAILABLE_STUDENTS_REPORT
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    visitorslist:[],
    particularvisitor:[],
    studentsavailable:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case VISITOR_ACTION:
            return { ...state, loading: true };       

        case ALL_VISITOR:
            return { ...state, loading: false, visitorslist: action.payload };     
            
        case ADD_VISITOR:
            return { ...state, loading: false };     
         
        case FETCH_VISITOR:
            return { ...state, loading: false, particularvisitor: action.payload };  
            
        case EDIT_VISITOR:
            return { ...state, loading: false }; 
            
        case DELETE_VISITOR:
            return { ...state, loading: false }; 
            
        case AVAILABLE_STUDENTS_REPORT:
            return { ...state, loading: false, studentsavailable: action.payload };      
        
        default: return { ...state };

     }
 }